/*
 * @Author: chenchaoqiang@leedarson.com
 * @Date: 2022-08-09 15:27:10
 * Copyright 2022 Leedarson, All Rights Reserved.
 */
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { paypalApi } from '@api';
import { IOrderGetPayUrl } from '@root/types/order';
import Toast from '@root/components/toast';
import { EPayMode, payModeStringMap } from '@root/constant';
const usePayPalResult = ({
  setPaying,
}: {
  setPaying?: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const navigate = useNavigate();

  const _baseUrl = `${window.location.origin}${process.env.REACT_APP_ROUTE_BASE_NAME}`;

  // 没有可选设备时默认订阅一份
  const getPayUrl = useCallback(
    ({
      type,
      orderId,
      startTime,
      payMode,
      cancelUrl = `${_baseUrl}/`,
      errorUrl = `${_baseUrl}/payFailed`,
      successUrl = `${_baseUrl}/paySuccess`,
    }: IOrderGetPayUrl) => {
      const _data = {
        orderId,
        type,
        startTime,
        payMode:
          payModeStringMap[payMode as number] ||
          payModeStringMap[EPayMode.PayPal],
        cancelUrl,
        errorUrl,
        successUrl,
      };

      paypalApi
        .getPayUrl(_data)
        .then((data: any) => {
          const { orderStatus, url } = data;
          if (orderStatus === 5 && !url) {
            Toast.destroy();
            // 初步测试是礼品卡购买会返回这个 orderStatus === 5 && !url
            navigate('/paySuccess/free', { replace: true });
          } else {
            window.location.href = url || cancelUrl;
            Toast.destroy();
          }
          if (setPaying) {
            setPaying(false);
          }
        })
        .catch(() => {
          if (setPaying) {
            setPaying(false);
          }
          navigate('/payFailed', { replace: true });
          Toast.destroy();
        });
    },
    [_baseUrl, navigate, setPaying],
  );

  return {
    getPayUrl,
  };
};

export default usePayPalResult;
